import { AutomotiveBusinessLevel } from "@enums/automotiveBusinessLevel.enum";
import { PpapCapability } from "@enums/ppapCapability.enum";
import { SupplierQuestionnaireStatus } from "@enums/supplierQuestionnaireStatus.enum";
import { YesNoConsidering } from "@enums/yesNoConsidering.enum";
import { YesNoNa } from "@enums/yesNoNa.enum";
import { Model } from "@interfaces/model.interface";
import { SupplierQuestionnaireApproval } from "@interfaces/models/supplierQuestionnaireApproval.interface";

export interface SupplierQuestionnaire extends Model {
	address: string;
	approvals?: SupplierQuestionnaireApproval[];
	as9100d?: YesNoConsidering;
	as9100dFileId?: number;
	automotiveBusinessLevel?: AutomotiveBusinessLevel;
	canWeSupportNotes: string;
	certificationConsideringNotes: string;
	companyName: string;
	completedByName: string;
	completedByPosition: string;
	completedOn?: Date;
	contactsLineData: string; // JSON format, SupplierQuestionnaireContactLineData[]
	contingencyPlan?: boolean;
	contingencyPlanFileId?: number;
	deviationProcess?: boolean;
	ediCapability?: YesNoConsidering;
	environmentalDate?: Date;
	environmentalIssues?: boolean;
	iatf16949?: YesNoConsidering;
	iatf16949FileId?: number;
	iso14001?: YesNoConsidering;
	iso14001FileId?: number;
	iso45001?: YesNoConsidering;
	iso45001FileId?: number;
	iso9001?: YesNoConsidering;
	iso9001FileId?: number;
	mmogLeCompleted?: boolean;
	outOfHoursContact: string;
	ppapLevel3?: PpapCapability;
	ppapSupportNotes: string;
	productsServices: string;
	qmsInPlace?: YesNoConsidering;
	riddorAccidents?: boolean;
	riddorDate?: Date;
	sanctionsOrigin?: YesNoNa;
	sentOn?: Date;
	sentToEmail: string;
	signature: string;
	signatureFingerprint?: string; // Set server-side on submit; read-only to the client
	signatureIpAddress?: string; // Set server-side on submit; read-only to the client
	status: SupplierQuestionnaireStatus;
	submittedOn?: Date;
	supplierId: number;
	telephoneFax: string;
	termsAccepted: boolean;
	termsAcceptedOn?: Date;
	termsAndConditionsDate?: Date;
	termsAndConditionsSigned?: boolean;
	termsVersion?: string;
	website: string;
}

export class SupplierQuestionnaire implements SupplierQuestionnaire {
	address = "";
	canWeSupportNotes = "";
	certificationConsideringNotes = "";
	companyName = "";
	completedByName = "";
	completedByPosition = "";
	contactsLineData = "[]";
	outOfHoursContact = "";
	ppapSupportNotes = "";
	productsServices = "";
	sentToEmail = "";
	signature = "";
	telephoneFax = "";
	termsAccepted = false;
	website = "";

	constructor(data?: Partial<SupplierQuestionnaire>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
